<template>
    <form class="main-filter" v-if="districtsUploaded">

            <div class="main-filter__inputs" >
                <div class="main-filter__input-wrap main-filter__input-wrap--search  col-lg-4 col-xl-2">
                    <auto-complete @search="search"  v-model="filterForm.name" @selectName="selectName"></auto-complete>
                </div>
                <div class="main-filter__input-wrap   col-lg-4 col-xl-2">
                    <multiselect
                        v-model="roomValues"
                        :options="rooms"
                        track-by="value"
                        :close-on-select="false"
                        label="value"
                        placeholder="Кол-во комнат"
                        :multiple="true"
                        selectLabel=""
                        selectedLabel=""
                        deselectLabel=""
                        @select=onSelectRoom

                        @remove=onRemoveRoom
                    >
                      <template slot="option" slot-scope="props" >
                     <span class="multiselect__checkbox-label" >
                        <input class="multiselect__checkbox-input" type="checkbox" v-model="props.option.checked" @focus.prevent/>
                        <span class="multiselect__checkbox-checkmark "></span>
                          {{props.option.value }}
                      </span>
                      </template>
                      <template slot="tag">{{''}}</template>
                      <template slot="selection" slot-scope="{ values, search, isOpen }">
                        <div class="multiselect__container multiselect__single"  v-if="values.length &amp;&amp; !isOpen">
                           <span class="multiselect__placeholder">
                         Кол-во комнат
                        </span>
                        </div>
                      </template>
                        <span slot="noOptions" class="multiselect__helper">
                            Нет данных
                        </span>
                        <span slot="noResult" class="multiselect__helper">Не найдено</span>
                    </multiselect>
                  <div class="main-filter__input-alert" v-if="roomValues.length > 0" @click.prevent="clearSelect('room')">
                    <span class="main-filter__input-alert-text">
                    {{num_word(roomValues.length, words_1)}} {{roomValues.length}} {{num_word(roomValues.length, words)}}
                    </span>
                    <div class="main-filter__input-alert-close-wrap">
                    <svg viewBox="0 0 10 10" class="main-filter__input-alert-close" >
                      <use xlink:href="/assets/site/images/sprites.svg?ver=41#sprite-close"></use>
                    </svg>
                    </div>
                  </div>
                </div>
                <div class="main-filter__input-wrap  col-lg-4 col-xl-2">
                    <multiselect

                        v-model="yearValues"
                        :options="years"

                        placeholder="Год сдачи"
                        track-by="value"
                        :close-on-select="false"

                        :multiple="true"
                        selectLabel=""

                        deselectLabel=""

                        @select=onSelectYear
                        @remove=onRemoveYear
                    >
                      <template slot="option" slot-scope="props" >
                      <span class="multiselect__checkbox-label">
                        <input class="multiselect__checkbox-input" type="checkbox" v-model="props.option.checked" @focus.prevent/>
                        <span class="multiselect__checkbox-checkmark "></span>
                          {{props.option.value }}
                      </span>
                      </template>
                      <template slot="tag">{{''}}</template>
                      <template slot="selection" slot-scope="{ values, search, isOpen }">
                        <div class="multiselect__container multiselect__single"  v-if="values.length &amp;&amp; !isOpen">
                           <span class="multiselect__placeholder">
                          Год сдачи
                        </span>
                        </div>
                      </template>
                        <span slot="noOptions" class="multiselect__helper">
                            Нет данных
                        </span>
                        <span slot="noResult" class="multiselect__helper">Не найдено</span>
                    </multiselect>
                    <div class="main-filter__input-alert" v-if="yearValues.length > 0" @click.prevent="clearSelect('year')">
                      <span class="main-filter__input-alert-text">
                        {{num_word(yearValues.length, words_1)}} {{yearValues.length}} {{num_word(yearValues.length, words)}}
                      </span>
                      <div class="main-filter__input-alert-close-wrap">
                        <svg viewBox="0 0 10 10" class="main-filter__input-alert-close" >
                          <use xlink:href="/assets/site/images/sprites.svg?ver=41#sprite-close"></use>
                        </svg>
                      </div>
                    </div>
                </div>

                <div class="main-filter__input-wrap   col-lg-4 col-xl-2">
                    <multiselect
                        v-model="districtValues"
                        :options="districts"
                        placeholder="Район"

                        :multiple="true"
                        track-by="value"
                        :close-on-select="false"
                        selectLabel=""
                        selectedLabel=""
                        deselectLabel=""
                        @select=onSelectDistrict

                        @remove=onRemoveDistrict
                    >
                      <template slot="option" slot-scope="props"  >
                      <span class="multiselect__checkbox-label">
                        <input class="multiselect__checkbox-input" type="checkbox" v-model="props.option.checked" @focus.prevent/>
                        <span class="multiselect__checkbox-checkmark "></span>
                          {{props.option.value }}
                      </span>
                      </template>
                      <template slot="tag">{{''}}</template>
                      <template slot="selection" slot-scope="{ values, search, isOpen }">
                        <div class="multiselect__container multiselect__single"  v-if="values.length &amp;&amp; !isOpen">
                         <span class="multiselect__placeholder">
                            Район
                        </span>
                        </div>
                      </template>
                      <span slot="noOptions" class="multiselect__helper">
                            Нет данных
                        </span>
                      <span slot="noResult" class="multiselect__helper">Не найдено</span>
                    </multiselect>
                  <div class="main-filter__input-alert" v-if="districtValues.length > 0" @click.prevent="clearSelect('district')">
                    <span class="main-filter__input-alert-text">
                      {{num_word(districtValues.length, words_1)}} {{districtValues.length}} {{num_word(districtValues.length, words)}}
                    </span>
                    <div class="main-filter__input-alert-close-wrap">
                      <svg viewBox="0 0 10 10" class="main-filter__input-alert-close" >
                        <use xlink:href="/assets/site/images/sprites.svg?ver=41#sprite-close"></use>
                      </svg>
                    </div>
                  </div>
                </div>

                <div class="main-filter__input-wrap   col-lg-4 col-xl-2">

                    <div class="main-filter__input-group">

                      <label  class="main-filter__input-group-flex main-filter__input-group-flex--first">
                        <number-input :placeholder="'Площадь от'"
                                      v-model.number="filterForm.square_from"
                                      v-on:keyup.enter="search"></number-input>
                      </label>
                      <label  class="main-filter__input-group-flex main-filter__input-group-flex--last">
                        <number-input placeholder="до"
                                      v-model="filterForm.square_to"
                                      v-on:keyup.enter="search"></number-input>
                      </label>
                     <span class="main-filter__input-group-text">
                      м²
                    </span>
                    </div>
                </div>

                <div class="main-filter__input-wrap   col-lg-4 col-xl-2">
                    <div class="main-filter__input-group" >
                      <label  class="main-filter__input-group-flex main-filter__input-group-flex--first main-filter__input-group-flex--first-price" >
                        <number-input placeholder="Цена от"
                                      v-model="filterForm.apartment_price_from"
                                      v-on:keyup.enter="search"></number-input>
                      </label>
                      <label  class="main-filter__input-group-flex main-filter__input-group-flex--last main-filter__input-group-flex--last-price" >
                        <number-input placeholder="до"
                                      v-model="filterForm.apartment_price_to"
                                      v-on:keyup.enter="search"></number-input>
                      </label>
                      <span class="main-filter__input-group-text">
                        руб.
                      </span>
                    </div>
                </div>
            </div>

            <div class="main-filter__btns">
                <button class="btn button button--big button-white-transparent main-filter__map-btn" @click.prevent="prepareFilter('map')">
                    Показать на карте
                </button>
                <button type="submit" class="btn button button--big button-red main-filter__search-btn" @click.prevent="prepareFilter('search')">Найти</button>
            </div>
    </form>
</template>
<script>
    import Multiselect from 'vue-multiselect'
    import AutoComplete from './autocomlete/index'
    import NumberInput from './common/number-input'
    export default {
      props: {
        options: {
         type:Object,
          default:{}
        }
      },
        components: { Multiselect, AutoComplete, NumberInput },
        data() {
            return {
                filterForm: {
                    name:'',
                    square_from:null,
                    square_to:null,
                    apartment_price_from:null,
                    apartment_price_to:null,
                    rooms: [],
                    districts:[],
                    years:[],
                },
                squareFocus:false,
                priceFocus:false,
                words:['элемент', 'элемента', 'элементов'],
                words_1:['Выбран', 'Выбрано', 'Выбрано'],
                districtValues:[],
                yearValues:[],
                roomValues:[],
                rooms: ['Студия','1','2', '2-смарт','3', '3-смарт','4', '4-смарт', '5'],
                districts:[],
                years: ["Сданные",'2021','2022','2023','2024','2025','2026','2027','2028'],
                start:false,
                districtsUploaded:false,

            }
        },
      watch: {
        districtValues(newValues) {

          this.filterForm.districts = newValues.map(obj => obj.value);
        }
      },
        methods: {
          squareToggle(val) {
           this.squareFocus = val;
          },
          priceToggle(val) {
         this.priceFocus = val;

          },
          num_word(value, words){
          value = Math.abs(value) % 100;
          var num = value % 10;
          if(value > 10 && value < 20) return words[2];
          if(num > 1 && num < 5) return words[1];
          if(num == 1) return words[0];
          return words[2];
        },
          clearSelect(type) {
            if(type === 'district') {
              this.districtValues =[];
              this.districts.forEach(function (item){
                item.checked = false;
              })
            }
            if(type === 'room') {
              this.roomValues =[];
              this.rooms.forEach(function (item){
                item.checked = false;
              })
            }
            if(type === 'year') {
              this.yearValues =[];
              this.years.forEach(function (item){
                item.checked = false;
              })
            }

          },
          onSelectDistrict (option) {
            let index = this.districts.findIndex(item => item.value==option.value);
           this.districts[index].checked = !this.districts[index].checked;

          },

          onRemoveDistrict (option) {
            let index = this.districts.findIndex(item => item.value==option.value);
            this.districts[index].checked = false;
            if(this.start) {
              let index2 = this.districtValues.findIndex(item => item.value==option.value);
              if(index2 != -1){
                this.districtValues.splice(index2,1);
              }
            }
          },
          onChangeSelectValue(value, id) {
            value.forEach(function(item, index, array) {
             if(item.checked ===  false) {
               value.splice(index,1);
             }
            });
          },
          onSelectYear (option) {
            let index = this.years.findIndex(item => item.value== option.value);
            this.years[index].checked = !this.years[index].checked;

          },

          onRemoveYear (option) {
            let index = this.years.findIndex(item => item.value===option.value);
            this.years[index].checked = false;
            if(this.start) {
              let index2 = this.yearValues.findIndex(item => item.value=== option.value);
              if(index2 != -1){
                this.yearValues.splice(index2,1);
                console.log("remove");
              }
            }
          },
          onSelectRoom (option) {

            let index = this.rooms.findIndex(item => item.value== option.value);

            this.rooms[index].checked = !this.rooms[index].checked;
            


          },

          onRemoveRoom (option) {
            let index = this.rooms.findIndex(item => item.value==option.value);
            this.rooms[index].checked = false;
            if(this.start) {

              let index2 = this.roomValues.findIndex(item => item.value== option.value);
              console.log(index2)
              if(index2 != -1){
                this.roomValues.splice(index2,1);
              }
            }

          },
            selectName(data) {
                this.filterForm.name = data;
                axios.post('/api/search/autocomplete/building',{name:data})
                    .then((response) => {
                      console.log(response.data)
                        if(response.data.exists) {
                            window.location.href = response.data.url;
                        }


                    })
            },

          prepareFilter(type) {
            this.filterForm.rooms = this.roomValues.map(function (item){
              return item.value;
            });

            this.filterForm.districts = this.districtValues.map(function (item){
              return item.value;
            });
            this.filterForm.years = this.yearValues.map(function (item){
              let value = item.value;
              return value;
            });
            if(this.filterForm.name || this.filterForm.rooms.length > 0 || this.filterForm.districts.length > 0 ||  this.filterForm.years.length > 0 || this.filterForm.apartment_price_from || this.filterForm.apartment_price_to || this.filterForm.square_from || this.filterForm.square_to) {
              if(type === 'search') {
                this.search();
              }
              if(type === 'map') {
                this.showOnMap()
              }
            }

          },
            search() {

              axios.post('/api/building/search',this.filterForm)
                  .then((response) => {
                    window.location.href = response.data;
                  })

            //this.$refs.filterForm.submit()
            },
            getDistricts() {
                axios.get('/api/districts', {params: {type:'building'}})
                    .then((response) => {
                        this.districts = response.data.map(function (item){
                          return {value:item, checked:false}
                        });
                    })
              .finally(() => {
                if(this.filterForm.districts.length > 0) {
                  let vm = this;
                  this.filterForm.districts.forEach(function(item, i, arr) {
                    vm.districtValues[i] = {
                      value:item,
                      checked:true
                    }
                    vm.onSelectDistrict(vm.districtValues[i]);
                  });
                  this.districtsUploaded =true;
                } else {
                  this.districtsUploaded =true;
                }
              })
            },
            showOnMap() {

                    axios.post('/api/building/show-on-map', this.filterForm)
                        .then((response) => {
                            window.location.href = response.data;
                        })
            },
        },
        mounted() {
            this.getDistricts();
         this.years = this.years.map(function (item){
            return {value:item, checked:false}
          });
          this.rooms = this.rooms.map(function (item){
            return {value:item, checked:false}
          });
          for(var key in this.options) {
            if (typeof this.filterForm[key] !== "undefined") {
              this.filterForm[key] = this.options[key];
            }
          }
          if(Object.keys(this.options).length === 0) {
            this.start = true;
          }
          if(Object.keys(this.options).length > 0) {
            let vm = this;

            if(this.filterForm.years.length > 0) {

              this.filterForm.years.forEach(function(item, i, arr) {
                vm.yearValues[i] = {
                  value:item,
                  checked:true
                }
                vm.onSelectYear(vm.yearValues[i]);
              });
            }
            if(this.filterForm.rooms.length > 0) {
              this.filterForm.rooms.forEach(function(item, i, arr) {
                vm.roomValues[i] = {
                  value:item,
                  checked:true
                }
                vm.onSelectRoom(vm.roomValues[i]);
              });
            }
            setTimeout(() => {
              this.start = true;
            }, 0);
          }

        }
    }
</script>

